export const routesPersonelDosyalari = [
  {
    path: "/personel_dosyalari",
    name: "personel_dosyalari",
    component: () => import("@/views/personel/personel_dosyalari/index.vue"),
    meta: {
      public: false,
      title: "personel.Personel Dosyaları",
      yetki: { k: [1013402] },
    },
  },
]
